import React from 'react';
import cx from 'classnames';

// TODO Review use of this class by reading https://lets-do-this.atlassian.net/browse/LDS-42
import { GLOBAL_FORM_STYLES_CLASS } from '@/globalClasses';

import { checkbox } from '../styles.module.css';

export const CheckboxRaw = ({
  className,
  inputProps,
  name,
  id,
  checked,
  label: checkboxLabel,
}) => {
  const inputId = `${id}-${name}`;

  return (
    <div className={cx(className, checkbox, GLOBAL_FORM_STYLES_CLASS)}>
      <input
        key={`${id}-${checked}`}
        id={inputId}
        type="checkbox"
        defaultChecked={checked}
        name={name}
        {...inputProps}
      />
      <label htmlFor={inputId}>{checkboxLabel}</label>
    </div>
  );
};
